import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { Box, debounce, IconButton } from '@mui/material';
import Input from '@mui/material/Input';
import React, { useCallback, useEffect, useState } from 'react';
import { useSearch } from '../../contexts';

const SearchBox: React.FC = () => {
  const { query, setQuery } = useSearch();
  const [inputValue, setInputValue] = useState(query);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedChangeHandler = useCallback(debounce(setQuery, 500), [
    setQuery,
  ]);

  useEffect(() => {
    if (undefined !== query) {
      setInputValue(query);
    }
  }, [query]);

  const onSearchChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setInputValue(e.target.value);
    debouncedChangeHandler(e.target.value);
  };

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      if ((e.target as HTMLInputElement).value === '') {
        setQuery('');
      } else {
        setQuery((e.target as HTMLInputElement).value);
      }
    }
  };

  const onKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Backspace' && '' === (e.target as HTMLInputElement).value) {
      setQuery('');
    }
  };

  const clearSearch = (e: React.MouseEvent<HTMLButtonElement>) => {
    setQuery('');
    setInputValue('');
  };

  const activateSearch = (e: React.MouseEvent<HTMLButtonElement>) => {
    setQuery(inputValue);
  };

  return (
    <Box
      className={'search-box'}
      sx={{
        height: 40,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        paddingLeft: 2,
        paddingRight: 1,
        gap: 0.5,
      }}
    >
      <Input
        title="Filter"
        placeholder="Filter"
        value={inputValue}
        aria-label="search"
        onChange={onSearchChange}
        onKeyDown={onKeyDown}
        onKeyUp={onKeyUp}
        size="small"
        disableUnderline={true}
        sx={{
          color: 'inherit',
          flex: 1,
          minWidth: 0,
          '& input': {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          },
        }}
      />
      <IconButton
        title="Activate Search"
        aria-label="Search"
        sx={{
          color: 'inherit',
          flexShrink: 0,
          minWidth: 'auto',
        }}
        onClick={activateSearch}
      >
        <SearchIcon />
      </IconButton>
      <IconButton
        title="Clear Search"
        aria-label="Clear Search"
        sx={{
          color: 'inherit',
          flexShrink: 0,
          minWidth: 'auto',
        }}
        onClick={clearSearch}
      >
        <CloseIcon />
      </IconButton>
    </Box>
  );
};

export default SearchBox;
